export default "__VITE_ASSET__BfHPNPne__"